// Make variables global, if you want to use them outside js file bundled by webpack (inline HTML).
// If a variable on the right side is not shared among modules, you need to edit webpack.ProvidePlugin's
// parameter first, or you shouldn't add the equivalent to the module in which the variable is defined.
window.$ = $;


